import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=0bc4c719&"
import script from "./PushList.vue?vue&type=script&lang=js&"
export * from "./PushList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports